import {RestService} from "@/services/rest/RestService";
import {ProductFiltersAPIApi} from "@/api/pharma-cpc-mgmt";
import {ProductFilterOverviewRestDto, ProductFilterRestDto} from "@/api/pharma-cpc-mgmt/models";
import {removeEmptyProductFilterConditions} from "@/store/pharma-cpc-mgmt/middleware";

export class ProductFiltersRestService extends RestService {

    private apiService: ProductFiltersAPIApi;

    protected constructor() {
        super();

        this.apiService = new ProductFiltersAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cpcUrl);
    }

    public async findProductFilters(onlyNamedFilters: boolean|null = null): Promise<ProductFilterOverviewRestDto[]> {
        const response = await this.apiService.findProductFilters(null, onlyNamedFilters);

        return response.data.results;
    }

    public async deleteProductFilter(filterCode: string): Promise<void> {
        await this.apiService.deleteProductFilter(filterCode);
    }

    public async findComplexProductFilter(filterCode: string): Promise<ProductFilterRestDto> {
        const response = await this.apiService.findComplexProductFilter(filterCode);

        return response.data;
    }

    public async saveComplexProductFilter(body: ProductFilterRestDto, filterCode: string): Promise<void> {
        const copiedFilter: ProductFilterRestDto = {...body};
        removeEmptyProductFilterConditions(copiedFilter);

        await this.apiService.syncComplexProductFilter(copiedFilter, filterCode);
    }
}
